import React from 'react';
import { HeaderProps, Header } from 'semantic-ui-react';

import PageTitle from './PageTitle';
import PageHeader from './Header';
import Paragraph from './Paragraph';
import Label from './Label';

type State = {};

type Props = HeaderProps;

export default class Typography extends React.Component<Props, State> {
  static Title = PageTitle;
  static Header = PageHeader;
  static Paragraph = Paragraph;
  static Label = Label;

  render() {
    return <Header {...this.props} />;
  }
}
